<template>
	<div> 
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			 <a-button size="small"   icon="search" @click="queryData" :loading="loading" style="margin:0 0.9375rem;">查询</a-button>
			 <a-button size="small"   icon="file" @click="exportData" :loading="exportLoading">导出</a-button>
		</div>
		<a-table size="small" :columns="columns" :data-source="dataList"  bordered  rowKey="MID"  :loading="loading"
						:pagination="false"  :scroll="{y:400}" @change="handleTableChange">
			<span slot="readTimeSlot" slot-scope="text, record">
				{{getTimeFormatter(record.readtime)}}
			</span>
			<template></template>
			<template slot="action" slot-scope="text, record">
				<a-button size="small" type="link" @click="showHistory(record)">历史读数</a-button>
			</template>
		</a-table>
		<a-drawer title="历史读数"  :visible="showHistoryFlag" width="520" @close="showHistoryFlag = false" :destroyOnClose="true"  :maskClosable="true">
			<MeterReadHistory  :theId="theObj.MID"/>
		</a-drawer>
	</div>
</template>

<script>
	import MeterReadHistory from '../components/MeterReadHistory.vue' 
	export default{
		components:{
			MeterReadHistory,
		},
		data(){
			const  columns = [
				{
					title: '#',
					dataIndex: 'index',
					key: 'index',
					align: 'center',
					width: 50,
					customRender: (text,record,index) => `${index+1}`,
				},
				{
					title: '水费号',
					dataIndex: 'CID',
					width:85,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户号',
					dataIndex: 'customerNum',
					width:85,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户名',
					dataIndex: 'CustomerName',
					width:120,
					className:'v-cell',
					align:'center',
				},
				{
					title: '地址',
					dataIndex: 'CustomerAddr',
					width:100,
					className:'v-cell',
					align:'center',
				},
				{
					title: '电话',
					dataIndex: 'CustomerMobile',
					width:100,
					className:'v-cell',
					align:'center',
				},
				{
					title: '抄表时间',
					dataIndex: 'readtime',
					width:145,
					className:'v-cell',
					align:'center',
					scopedSlots:{customRender:'readTimeSlot'}
				},
				{
					title: '表读数',
					dataIndex: 'readdata',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '余额',
					dataIndex: 'CustomerBalance',
					width:80,
					className:'v-cell',
					align:'center',
				},
				{
				    title: '操作',
					dataIndex: 'MID',
					width:80,
					className:'v-cell',
					align:'center',
				    scopedSlots: { customRender: 'action' },
				},
			];
			return{
				showHistoryFlag:false,
				columns,
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				loading:false,
				exportLoading:false,
				pagination:null,
				page:null,
				pageSize:null,
				theObj:{},
			}
		},
		methods:{
			showHistory:function(item){
				this.theObj = item;
				this.showHistoryFlag = true;
			},
			handleTableChange:function(pagination,filters,sorter){
				this.pageSize = pagination.pageSize;
				this.page = pagination.current;
				this.pagination = JSON.parse(JSON.stringify(pagination));
			},
			exportData:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_SIX_MONTH_NO_CHANGE_EXPORT_URL);
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = this.theNeighbor.label+'.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			queryData:function(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_SIX_MONTH_NO_CHANGE_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
